import { Grid } from '@mui/material';
import { Link } from '@nutrien/ddc-components';
import { Link as RouterLink } from 'react-router-dom';

const Navigation = () => {
  return (
    <>
      <Grid container direction={'row'} spacing={2}>
        <Grid item>
          <Link component={RouterLink} to="/home">
            Home
          </Link>
        </Grid>
        <Grid item>
          <Link component={RouterLink} to="/one">
            One
          </Link>
        </Grid>
        <Grid item>
          <Link component={RouterLink} to="/two">
            Two
          </Link>
        </Grid>
      </Grid>
    </>
  );
};

export default Navigation;
